import { render } from "./alarmController.vue?vue&type=template&id=2d70a8aa&scoped=true"
import script from "./alarmController.vue?vue&type=script&lang=js"
export * from "./alarmController.vue?vue&type=script&lang=js"

import "./alarmController.vue?vue&type=style&index=0&id=2d70a8aa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d70a8aa"]])

export default __exports__